import { createContext, useContext } from 'react';

export interface ImagePathConfig {
  countryFlagPath: string;
  teamShirtPath: string;
  /** GK-specific shirt folder for this competition format; omitted where no distinct GK kit exists. */
  teamShirtGkPath?: string;
}

export const IMAGE_PATHS_BY_FORMAT = {
  knockout: { countryFlagPath: 'country-flags', teamShirtPath: 'teams/shirts' },
  classic_season_long: {
    countryFlagPath: 'teams/logos',
    teamShirtPath: 'teams/epl-shirts',
    teamShirtGkPath: 'teams/epl-shirts/gk',
  },
} as const;

export const ImagePathContext = createContext<ImagePathConfig | null>(null);

export const useImagePathConfig = () => useContext(ImagePathContext);
